import { AppLayout, Layout, NotFound } from "components";
import { useAppDispatch, useAppSelector } from "hooks";
import SignIn from "pages/auth/SignIn";
import { Events } from "pages/codes/events";
import { Hunters } from "pages/codes/hunters";
import { Home } from "pages/home";
import { DayServices, NextServices, ServicesHistorical, ServiceDetail } from "pages/services";
import { Banners, Categories, Countries, EditZone, GoodLooks, ManipulateGoodLook, Products, Zones } from "pages/settings";
import WhatsAppBot from "pages/bot/WhatsAppBot";
import QuizDashboard from "pages/quiz/QuizDashboard";
import QuizManager from "pages/quiz/QuizManager";
import QuizEditor from "pages/quiz/QuizEditor";
import { Navigate, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import PrivateRoute from "./PrivateRoute";
import { setBanners, setCategories, setCountries, setProducts, setZones } from "store/catalogs/catalogs_t";
import Wallets from "pages/codes/wallets/Wallets";
import ValidateGL from "pages/settings/goodLookeroAuth/ValidateGoodLooker";
import Usersoperator from "pages/settings/users/Usersoperator";
import Roles from "pages/settings/roles/Roles";

export default function AppRouter () {
    const { data } = useAppSelector(({ user }) => user);
    const { token } = data;
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (token) {
            dispatch(setBanners());
            dispatch(setProducts());
            dispatch(setZones());
            dispatch(setCountries());
            dispatch(setCategories());
        }
    }, [token])
    
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<SignIn />} />
                <Route path="not-found" element={<NotFound />} />
            </Route>
            <Route element={<AppLayout />}>
                <Route
                    path="home"
                    element={
                        <PrivateRoute>
                            <Home />
                        </PrivateRoute>
                    }
                />
                <Route path="services">
                    <Route
                        index
                        element={
                            <Navigate replace to={"day-services"}/>
                        }
                    />
                    <Route
                        path="day-services"
                        element={
                            <PrivateRoute resource="sales">
                                <DayServices />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="nexts"
                        element={
                            <PrivateRoute resource="sales">
                                <NextServices />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="historical"
                        element={
                            <PrivateRoute resource="sales">
                                <ServicesHistorical />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="detail/:id"
                        element={
                            <PrivateRoute resource="sales">
                                <ServiceDetail />
                            </PrivateRoute>
                        }
                    />
                </Route>
                <Route
                    path="coupons"
                    element={
                        <PrivateRoute resource="promocodes">
                            <Events />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="hunters"
                    element={
                        <PrivateRoute resource="hunters">
                            <Hunters />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="wallets"
                    element={
                        <PrivateRoute resource="wallets">
                            <Wallets />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="countries"
                    element={
                        <PrivateRoute resource="countries">
                            <Countries />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="zones"
                    element={
                        <PrivateRoute resource="zones">
                            <Zones />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="zones/:id"
                    element={
                        <PrivateRoute resource="zones">
                            <EditZone  />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="categories"
                    element={
                        <PrivateRoute resource="categories">
                            <Categories />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="products"
                    element={
                        <PrivateRoute resource="sale_items">
                            <Products />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="banners"
                    element={
                        <PrivateRoute resource="banners">
                            <Banners />
                        </PrivateRoute>
                    }
                />
                <Route path="goodlooks">
                    <Route
                        index
                        element={
                            <PrivateRoute resource="employees">
                                <GoodLooks />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="add"
                        element={
                            <PrivateRoute resource="employees">
                                <ManipulateGoodLook />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path=":id"
                        element={
                            <PrivateRoute resource="employees">
                                <ManipulateGoodLook />
                            </PrivateRoute>
                        }
                    />
                </Route>
                <Route
                        path="bot"
                        element={
                            <PrivateRoute resource="whatsapp">
                                <WhatsAppBot />
                            </PrivateRoute>
                        }
                    />
                <Route path="quiz">
                    <Route
                        index
                        element={
                            <PrivateRoute>
                                <QuizDashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="manage"
                        element={
                            <PrivateRoute>
                                <QuizManager />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="manage/new"
                        element={
                            <PrivateRoute>
                                <QuizEditor />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="manage/:id"
                        element={
                            <PrivateRoute>
                                <QuizEditor />
                            </PrivateRoute>
                        }
                    />
                </Route>
                <Route
                        path="goodlooks/auth"
                        element={
                            <PrivateRoute resource="employees">
                                <ValidateGL />
                            </PrivateRoute>
                        }
                    />
                <Route
                    path="operators"
                    element={
                        <PrivateRoute resource="users">
                            <Usersoperator />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="roles"
                    element={
                        <PrivateRoute resource="roles">
                            <Roles />
                        </PrivateRoute>
                    }
                />
            </Route>
            <Route path="*" element={<Navigate to="not-found"/>} />
        </Routes>
    )
}